<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/cancelarRequisicao"> Requisicao </router-link>
    </div>
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col cols="12" sm="8">
            <v-text-field
              label="Justificativa"
              v-model="justificativa"
              maxlength="200"
              counter
              :rules="[(v) => !!v || 'O campo Justificativa é obrigatório']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="N° Requisição"
              v-model="numRequisicao"
              readonly
              :counter="200"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Unidade Administrativa"
              v-model="unidadeAdministrativa"
              readonly
              :counter="200"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Local Entrega"
              v-model="localEntrega"
              readonly
              :counter="200"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Ativa"
              v-model="ativa"
              readonly
              :counter="200"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Prioridade"
              v-model="prioridade"
              readonly
              :counter="200"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Status"
              v-model="status"
              readonly
              :counter="200"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12" sm="6">
            <v-text-field
              label="Observações"
              v-model="observacoes"
              readonly
              :counter="200"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Requisitante"
              v-model="requisitante"
              readonly
              :counter="200"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="O.S. Origem"
              v-model="osOrigem"
              readonly
              :counter="200"
            ></v-text-field>
          </v-col>
        </v-row>


        <v-card>
        <v-data-table
          :headers="headers"
          hide-default-footer
          :items="requisicoesLocal"
          :loading="loading"
          loading-text="Buscando dados..."
        >
        </v-data-table>
      </v-card>


      </v-form>
      <v-row align="center-left">
        <v-col class="text-right">
          <v-btn to="/requisicao" color="error" class="mr-4"> Voltar </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4"> Inativar </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { editarRequisicaoAsync } from "../../../services/requisicaoService";
import { mapState } from "vuex";
import { getUserPermission } from "@/services/loginService";

export default {
  name: "editarRequisicao",
  data: () => ({
    overlay: false,
    valid: true,
    numRequisicao: null,
    justificativa: null,
    unidadeAdministrativa: null,
    localEntrega: null,
    ativa: false,
    prioridade: null,
    status: null,
    observacoes: null,
    requisitante: null,
    osOrigem: null,
    nome: null,
    codFabricante: null,
    unidade: null,
    qtde: null,
    observacaoProduto: null,
    centroCusto: null,
    produtos:[],
    headers:[
    { text: "Id Produto", value: "idProduto", sortable: false },
      { text: "Quantidade", value: "quantidade", sortable: false },
    ],
    options: {
      locale: "pt-BR",
      prefix: "R$",
      precision: 2,
    },
  }),
  computed: {
    ...mapState("requisicao", ["requisicao"]),
  },
  methods: {
    async enviar() {
      this.overlay = true;
        const resposta = await inativarRequisicaoAsync(this.requisicao.id);
        if (resposta) {
          this.overlay = false;
          this.$alert(resposta.message, "Desculpe, falha na operação!", "error");
        } else {
          this.overlay = false;
          this.$router.push("/cancelarRequisicao");
        }
      },
    }, 
    created: function () {
      //this.readOnly = !getUserPermission(1);
      this.readOnly = true;
      this.produtos = this.requisicao.produtos;
    },
  components: {
    TabNavegacaoEquipamento: () =>
      import("@/components/Tabs/TabCadastroEquipamento"),
  },
};
</script>
